var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWaves(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, ["title", "titleId"]);
  return /*#__PURE__*/React.createElement("svg", _extends({
    className: "waves",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 24 150 28",
    preserveAspectRatio: "none",
    shapeRendering: "auto",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "gentle-wave",
    d: "M-160 44c30 0 58-18 88-18s 58 18 88 18 58-18 88-18 58 18 88 18 v44h-352z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "parallax"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 0,
    fill: "rgba(255,255,255,0.7"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 3,
    fill: "rgba(255,255,255,0.5)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 5,
    fill: "rgba(255,255,255,0.3)"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#gentle-wave",
    x: 48,
    y: 7,
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWaves);
export default __webpack_public_path__ + "static/media/waves.6c8f3b5c.svg";
export { ForwardRef as ReactComponent };